import { AfterViewInit, Component } from '@angular/core';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})

export class MainComponent implements AfterViewInit {

  ngAfterViewInit() {
    import('../../../assets/script/sidebar-script.js' as any)
  }
}